import React, {Component} from 'react';
import Spinner from 'react-spinner-material';
import couterpart from 'counterpart';
import {FaUpload} from 'react-icons/fa';
import {MdFileUpload} from 'react-icons/md';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import ItemDataService from '../services/ItemDataService';
import "../css/style.css";
import { ICON_COLOR } from '../icon';

class UploaderItemImage extends Component{
    state = {
        file: null,
        selectedFilenames:null,
        spinnerVisible: false
    }

    handleFile(e){
        let file = e.target.files;
        this.setState({file}, ()=>{
            if (file != null && file.length > 0){
                var selectedFiles = "";
                var fileSep = "";
                for(var i=0; i<file.length;i++){
                    selectedFiles += fileSep + file[i].name;
                    fileSep = ",";
                }
                
                this.setState({
                    selectedFilenames: selectedFiles
                });
            }
        });
    }

    handleUpload(e){
        let files = this.state.file;
        let msg = "";
        try{
            this.setState({spinnerVisible: true}, () =>{
                if ((files === null) || (files === undefined) || (files.length < 1)){
                    msg = couterpart.translate("msg_upload_validate_file");
                    ToastsStore.error(msg);
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return;
                }

                if ((this.props.itemId === null) || 
                    (this.props.itemId === undefined) || 
                    (this.props.itemId < 1)){
                    msg = couterpart.translate("msg_upload_validate_id");
                    ToastsStore.error(msg);
                    this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    return; 
                }

                if (files != null){
                    ItemDataService.uploadItemImages(files, this.props.itemId).then(response => {
                        this.clearInputFile();
                        this.props.handleUpdate(e);
                        this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
                    });
                }
            });
        }catch(e){
            this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
        }            
    }

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    clearInputFile(e){
        //this.setState({file: null, selectedFilenames: '',inputKey:''});
    }

    render(){
        return (
            <div>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <h3>{this.props.caption}</h3>
                <form>
                    <div className="">
                        <label htmlFor="file"><MdFileUpload color="green"/> 
                        {this.state.selectedFilenames}</label>
                        <input key={this.state.inputKey} type="file" name="file" id="file" multiple onChange={(e) => this.handleFile(e)}/>
                    </div>
                    <button className="myButton" type="button" 
                        onClick={(e) => this.handleUpload(e)}>
                        <FaUpload color={ICON_COLOR}/>&nbsp;
                        {couterpart.translate('button_upload')}
                    </button>
                    <Spinner size={25} spinnerColor={ICON_COLOR} 
                        spinnerWidth={2} 
                        visible={this.state.spinnerVisible} />
                </form>
            </div>
        );
    }
}

export default UploaderItemImage;